import styled from "styled-components";
import { tokens } from "../../../../../design/tokens";

export const Thumb = styled.img`
  display: block;
  width: 160px;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: ${tokens.radius.sm};
  box-shadow: ${tokens.shadow.imageSeat};
`;

export const Title = styled.strong`
  color: ${tokens.color.textWhite};
`;

export const Muted = styled.span`
  color: ${tokens.color.textAsh};
`;

export const LinkOut = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 280px;
  color: ${tokens.color.textMist};
  text-decoration: underline;
  text-underline-offset: 3px;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover {
    color: ${tokens.color.marqueeGold};
  }

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 2px;
  }
`;
